import {
  ClockIcon,
  FolderIcon,
  LayoutDashboardIcon,
  MessageSquareIcon,
} from "lucide-react";
import { GrServices } from "react-icons/gr";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import "../sidebar/sidebar.css";

const Sidebar = () => {
  const { isOpen } = useSelector((state) => state.sidebar);
  const { pathname } = useLocation();

  return (
    <>
      <div
        className={`w-[280px] glass-header h-screen overflow-y-auto z-20 max-[770px]:hidden sticky top-[96px] ${
          !isOpen ? "" : "-translate-x-0"
        }`}
      >
        <div className="h-[96px] flex justify-left p-4 px-8 items-center">
          <Link to="/">
            <h1 className="text-3xl font-bold text-black">Superloopz</h1>
          </Link>
        </div>
        <ul className="client-ul p-4 text-black">
          <Link
            className={`client-link ${
              pathname.includes("dashboard") && "bg-[#d5e6f6]"
            } hover:bg-[#bddcf9]`}
            to={"/client/dashboard"}
          >
            <LayoutDashboardIcon className="text-muted-foreground size-6" />
            Dashboard
          </Link>

          {/* <Link className="link" to={"/admin/dashboard"}>Dashboard</Link> */}

          <Link
            className={`client-link ${
              pathname.includes("requests") && "bg-[#d5e6f6]"
            } hover:bg-[#d5e6f6]`}
            to={"/client/requests"}
          >
            <ClockIcon className="text-muted-foreground size-6" />
            Pending Requests
          </Link>
          <Link
            className={`client-link ${
              pathname.includes("my-services") && "bg-[#d5e6f6]"
            } hover:bg-[#d5e6f6]`}
            to={"/client/my-services"}
          >
            <GrServices className="text-muted-foreground size-6" />
            My Services
          </Link>
          <Link
            className={`client-link ${
              pathname.includes("mydocuments") && "bg-[#d5e6f6]"
            } hover:bg-[#d5e6f6]`}
            to={"/client/mydocuments"}
          >
            <FolderIcon className="text-muted-foreground size-6" />
            My Documents
          </Link>
          <Link
            className={`client-link ${
              pathname.includes("chats") && "bg-[#d5e6f6]"
            } hover:bg-[#d5e6f6]`}
            to={"/client/chats"}
          >
            <MessageSquareIcon className="text-muted-foreground size-6" />
            My Chats
          </Link>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
